import {combineReducers} from 'redux';

export default function snippetList(type) {
  const actionType = (action) => `schooladmin/${type}HistoryList/${action}`;
  const enityActionType = (action) => `schooladmin/${type}Histories/${action}`;

  const types = {
    SET_PAGE: actionType('SET_PAGE'),
    SET_TOTAL_PAGES: actionType('SET_TOTAL_PAGES'),
    SET_SELECTED_SNIPPET: actionType('SET_SELECTED_SNIPPET')
  };

  const entityTypes = {
    LOAD_SUCCESS: enityActionType('LOAD_SUCCESS')
  };

  // Reducers

  const page = (state = 1, action) => {
    switch (action.type) {
      case types.SET_PAGE:
        return action.page;
      default:
        return state;
    }
  };

  const totalPages = (state = 0, action) => {
    switch (action.type) {
      case entityTypes.LOAD_SUCCESS:
        return action.payload.result._meta.num_pages;
      default:
        return state;
    }
  };

  const selectedSnippet = (state = null, action) => {
    switch (action.type) {
      case types.SET_SELECTED_SNIPPET:
        return action.snippet;
      default:
        return state;
    }
  };

  // Action reducers

  const setPage = (page) => (dispatch) => dispatch({type: types.SET_PAGE, page});
  const setSnippet = (snippet) => (dispatch) => dispatch({type: types.SET_SELECTED_SNIPPET, snippet});

  const reducer = combineReducers({
    page,
    totalPages,
    selectedSnippet
  });

  const actions = {
    setPage,
    setSnippet,
  };

  return {
    reducer: reducer,
    actions: actions
  }
};